var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.09 1.387A2.911 2.911 0 0 0 8.956.5c-.832 0-1.544.296-2.135.887a2.911 2.911 0 0 0-.888 2.136v1.296H1.398a.625.625 0 0 0-.46.189.625.625 0 0 0-.188.458v3.887c0 .18.063.333.189.46a.625.625 0 0 0 .459.188h6.478c.18 0 .333-.063.459-.189a.625.625 0 0 0 .188-.459V5.466a.625.625 0 0 0-.188-.458.625.625 0 0 0-.46-.19h-.647V3.524c0-.477.168-.884.506-1.221a1.664 1.664 0 0 1 1.221-.506c.477 0 .884.168 1.222.506.337.337.506.744.506 1.221V5.25c0 .117.042.219.128.304a.415.415 0 0 0 .304.128h.431a.415.415 0 0 0 .304-.128.415.415 0 0 0 .128-.304V3.523c0-.832-.296-1.544-.887-2.136z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockedIcon);
export default ForwardRef;